// extracted by mini-css-extract-plugin
export default {"productGallery":"rO-z","inQuickShop":"sO-z"};